import { AttrField, OrmModel, PrimaryKey, UidField } from 'vuex-orm-decorators';
import { Model } from '@vuex-orm/core';
import { v4 as uuid } from 'uuid';
import ImageContract from '@/image/ImageContract';
import SizesContract from '@/image/SizesContract';

@OrmModel('inactive_images')
export default class InactiveImage extends Model implements ImageContract {
    @PrimaryKey()
    @UidField(() => uuid())
    public id!: string;

    @UidField(() => uuid())
    location_id!: string;

    @AttrField()
    public sizes!: SizesContract;
}
